<script lang="ts" setup>
import { MenuItem } from 'openvue/menuitem';

const emit = defineEmits(['toggle', 'logout', 'context']);
const { t: $t } = useI18n();
const router = useRouter();
const props = defineProps<{
    menu: boolean;
    noContext: boolean;
    userId?: string | null;
}>();
const contextRoot = (items: MenuItem[]): MenuItem => ({
    label: $t('menu.context'),
    items
});
const menuRoot = (items: MenuItem[]): MenuItem => ({
    label: $t('menu.profile'),
    items
});
const contextItem = () => ({
    label: $t('menu.switch'),
    icon: 'pi pi-arrow-right-arrow-left',
    command: () => emit('context')
});
const logoutItem = () => ({
    label: $t('menu.logout'),
    icon: 'pi pi-sign-out',
    command: () => emit('logout')
});
const userProfileItem = () => ({
    label: $t('menu.profile'),
    icon: 'pi pi-user',
    command: () => router.push(`/me`)
});
const items = computed<MenuItem[]>(() => {
    const globalItems = props.userId
        ? [userProfileItem(), logoutItem()]
        : [logoutItem()];
    if (props.noContext) {
        return [menuRoot(globalItems)];
    }
    return [contextRoot([contextItem()]), menuRoot(globalItems)];
});
</script>
<template>
    <AppHeaderRoot>
        <div class="flex items-center">
            <Button
                v-if="menu"
                class="ml-4 p-5 text-white hover:bg-white/32"
                text
                rounded
                size="large"
                severity="primary"
                icon="pi pi-bars"
                data-testid="menu-btn"
                @click="$emit('toggle')"
            />
            <router-link to="/">
                <img
                    class="ml-4 h-9"
                    src="@/assets/shapth-logo-lg.svg"
                    alt="logo"
                />
            </router-link>
        </div>
        <AppHeaderMenu :items="items" />
    </AppHeaderRoot>
</template>
